/* @ngInject */
const data = () => {
  const self = {}

  return self
}

export default data



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/area/services/data.service.js